const isDev = process.env.NODE_ENV !== "production";

// Dev-only diagnostics; errors always surface.
export const log = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  error: (...args) => console.error(...args),
};
